export default {
  base_url: window.REACT_APP_BASE_URL,
  base_login: window.REACT_APP_LOGIN_BASE_URL,
  api_context: window.REACT_APP_API_CONTEXT,
  registration_x_page: window.REACT_APP_REGISTRATION_X_PAGE,
  modal_registration_x_page: window.REACT_APP_MODAL_REGISTRATION_X_PAGE,
};
